import React, { useCallback } from 'react';
import { useAsync } from 'react-use';
import cn from 'classnames';
import { Element } from 'src/components';
import ContentService from 'src/services/ContentService';
import { Loader } from '@zmedia/bm-common/components/loader';
import { IContent } from 'src/interface';
import Item from './item';

interface IProps {
    content: IContent;
}

export default React.memo(function ContentsHistory({ content }: IProps) {
    const state = useAsync(
        () =>
            ContentService.getListHistory({
                listId: content.contentId,
            }),
        [content]
    );

    const items = state.value?.data?.items || ([] as IContent[]);
    const itemSize = state.value?.data?.itemSizeLimit || 1;

    const renderItems = useCallback(() => {
        return items.slice(0, itemSize).map((item: IContent, index: number) => {
            return <Item content={item} key={index} />;
        });
    }, [items]);

    if (state.loading) {
        return <Loader />;
    }

    if (!items.length) {
        return null;
    }

    return (
        <Element
            className={cn(
                'contents-history',
                'text-[var(--primary)]',
                'mt-[15px] mb-[12px]'
            )}
        >
            {renderItems()}
        </Element>
    );
});
